import React from 'react'
import FiltersProvider from './components/context'
import Filter from './Filter'

export default (p) => (
  <FiltersProvider>
    <Filter {...p} />
  </FiltersProvider>
)
